import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`

/* COLORS */
:root {
    --color-text-base: #1F2D3D;
    --color-background: #F9FAFC;
    --color-white: #F9FAFC;
    --color-border: #7A7786;
    --color-silver: #C2CEDB;
    --color-silver-light: #E5E9F2;
    --color-silver-light1: #F8F8F8;
    --color-silver-light2: #7A7786;
    --color-silver-dark: #3F3F46;
    --color-primary: #F5A201;
    --color-primary-light: #FFD35B;
    --color-primary-dark: #FFBA42;
    --color-secundary: #00537A;
    --color-secundary-light: #013C58;
    --color-secundary-dark: #0B1E33;
    --color-success: #14A38B;
    --color-warning: #F2AC57;
    --color-danger: #FF7171;
  }

  .f-right{
    float:right
  }

  .f-left{
    float:left
  }
  hr{
    border: 1px solid #E7EAF3; 
  }
  .container{
    padding:20px;
    width:100%;
    display:flex;
    justify-content:center;
    box-sizing: border-box;
    border-radius: 5px;

  }
  .container-box{
    margin-top:16px;
    background-color: #fff;
    padding: 20px;
    border-radius: 5px;
    box-shadow: 0px 0px 30px rgba(136, 152, 170, 0.15);
    border: 1px solid #E7EAF3;    
  }
  .titlePage{
    margin: 20px 0;
  }
  .link, .link:active{
    text-align:left;
    cursor: pointer;
    color: var(--color-secundary);
    text-decoration:none;
  }
  .link:hover{
    color: var(--color-primary);
  }

.bg-primary{
  background: var(--color-primary) !important
}
.bg-secundary{
  background: var(--color-secundary) !important
}

/*#region Reset*/
  *{
    margin: 0;
    padding: 0;
    outline: 0;
    box-sizing: border-box;
  }

  *::before,
  *::after {
    box-sizing: border-box;
  }

  body, #root {
    color: var(--color-text-base);
    background-color: var(--color-background);
    line-height: 1.5;
    min-height: 100vh;
    scroll-behavior: smooth;
    text-rendering: optimizeSpeed;
    -webkit-font-smoothing: antialiased !important
  }

  ul,
  ol {
    list-style: none;
  }

  img {
   max-width: 100%;
    display: block;
  }

  a, a:active{
    color: var(--color-secundary);
    text-decoration:none;
  }
  a:hover{
    color: var(--color-primary);
  }


/*#endregion Reset*/

/*#region Typography*/
  *, body, input, textarea, button {
    font-family: 'Roboto', 'sans-serif' !important;
  }
  h1{
    font-size: 60px;
    color: #1F2D3D
  }
  h2{
    font-size: 32px;
    color: #1F2D3D
  }
  h3{
    font-size: 24px;
    color: #1F2D3D
  }
  h4{
    font-size: 20px;
    color: #1F2D3D
  }
  h5{
    font-size: 16px;
    color: #1F2D3D
  }
  h6{
    font-size: 8px;
    color: #1F2D3D
  }
/*#endregion Typography*/

/*#region FORMS*/
  fieldset {
    width:100%;
    min-inline-size: auto;
    border: 0;
    padding: 8px;
  }
  .field-inline{
    width: 100%;
    margin: 6px 0;
    display: flex;
    flex-direction: row;
    align-items:center;
    label {
      color: var(--color-silver-light2);
      margin: 0 6px;
    }
    button{
      margin: 6px 6px;
    }
  }

  .field {
    width: 100%;
    margin: 6px 0;
    display: flex;
    flex-direction: column;
    label {
      color: var(--color-silver-light2);
      padding: 8px 0 6px;
      display: flex;
      align-items: center;
      justify-content: flex-start
    }
    .checkbox{
      display: flex;
      align-items: center;
      justify-content:flex-start;
      input{
        margin-right:16px;
      }
    }
  }
  input[type='checkbox'], input[type='radio'] {
    width: 18px;
    height: 18px;
    border-color:  var(--color-secundary) !important;
    cursor: pointer;
    &:checked
    {
    border-color:  #fff;
      background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10l3 3l6-6'/%3e%3c/svg%3e") !important;
      background-color: var(--color-secundary) !important;
    }
  }

  input,
  select,
  textarea {
    background-color: var(--color-background);
    color: var(--color-text-base);
    border: solid 1px var(--color-border);
    height: 48px;
    border-radius: 5px;
    padding-left: 16px;
    font-size: 14px;
  }
  select{
    width:100%
  }
  select option{
    max-width: 100%; text-overflow: ellipsis;
  }
  input::placeholder,
  select::placeholder,
  textarea::placeholder {
    color: var(--color-silver);
  }

  input:disabled,
  select:disabled,
  textarea:disabled {
    background-color: var(--color-silver-light1);
    cursor: not-allowed;
  }

  textarea{
    padding: 8px;
    height: 150px;
    resize:none;
  }
  input:focus,
  select:focus,
  textarea:focus {
    border: 1px solid var(--color-secundary);
  }

  input[type='file']{
    border:none;
    padding:0px;
  }

  .inputError{
    label, input{
    color:var(--color-danger);
    border-color:var(--color-danger);
      color:var(--color-danger);
    }
  }
  .inputSuccess{
    label, input{
    color:var(--color-success);
    border-color:var(--color-success);
      color:var(--color-success);
    }
  }
/*#endregion FORMS*/

/*#region Buttons*/
// format button
.btn{
  border: none;
  width: 100%;
  height: 48px;
  margin-top: 12px;;
  font-size: 18px;
  font-weight: 500;
  border-radius: 5px;
  text-transform: uppercase;
  color: var(--color-white) !important;
  cursor: pointer;
}

.btn-sm{
  border: none;
  width: 100%;
  height: 32px;
  margin-top: 12px;;
  font-size: 12px;
}
.btn:hover, .btn:active
{
  transition: 0.8s;
}
// button primary
.btn-primary{
  background-color: var(--color-primary) !important;
}
.btn-primary:hover, .btn-primary:active{
  background-color: var(--color-secundary) !important;
}
// button secundary
.btn-secundary{
  background-color: var(--color-secundary) !important;
}
.btn-secundary:hover, .btn-secundary:active{
  background-color: var(--color-primary) !important;
}
.btn-primary-outline{
  background-color: #fff;
  color: var(--color-primary) !important;
  border: solid 1px;
  border-color: var(--color-primary) !important;
}
.btn-primary-outline:hover, .btn-primary-outline:active{
  color: #fff !important;
  background-color: var(--color-primary) !important;
}
.btn-success-outline{
  background-color: #fff;
  color: var(--color-success) !important;
  border: solid 1px;
  border-color: var(--color-success) !important;
}
.btn-success-outline:hover, .btn-success-outline:active{
  color: #fff !important;
  background-color: var(--color-success) !important;
}
.btn-danger-outline{
  background-color: #fff;
  color: var(--color-danger) !important;
  border: solid 1px;
  border-color: var(--color-danger) !important;
}
.btn-danger-outline:hover, .btn-danger-outline:active{
  color: #fff !important;
  background-color: var(--color-danger) !important;
}
/*#endregion Buttons*/

.dropdown-menu.show{
  right:0;
}


@media (prefers-reduced-motion: reduce) {
  * {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
    scroll-behavior: auto !important;
  }
}
`;
